import {
  Container,
  SubTitle,
  InfoText
} from './styles'

export default function SoldItem ({ data: item }) {
  return (
    <Container>
      <InfoText>
        {item.name}
      </InfoText>
      <SubTitle>
        {item.count}
      </SubTitle>
    </Container>
  )
}
